export const DEFAULT_TIME_TO_CLOSE_CHECKIN = 45
